<div class="organization-switch-container">
  <h3>Switch Organization</h3>
  <div *ngIf="loading" class="loading">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
  <div *ngIf="!loading" class="organizations-list">
    <button
      *ngFor="let org of organizations"
      mat-button
      [class.active]="org.org_id === currentOrgId"
      (click)="switchOrganization(org.org_id)"
      class="org-button">
      <mat-icon>{{ org.org_id === currentOrgId ? 'check_circle' : 'business' }}</mat-icon>
      <span>{{ org.org_name }}</span>
    </button>
  </div>
</div>
